import { render } from "./TextAreaInput.vue?vue&type=template&id=2045f9db&scoped=true"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"

import "./TextAreaInput.vue?vue&type=style&index=0&id=2045f9db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2045f9db"]])

export default __exports__